<script>
import axios from 'axios';
import config from '@/utils/config';

export default {
  props: {
    user: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      questions: [
        { id: 1, text: "1. Sono felice e attivo", factor: "EXTRAVERSION", answer: null },
        { id: 2, text: "2. Imparo facilmente quello che studio", factor: "OPENNESS", answer: null  },
        { id: 3, text: "3. Sono amichevole con gli altri a scuola", factor: "AGREEABLENESS", answer: null  },
        { id: 4, text: "4. So molte cose", factor: "OPENNESS", answer: null  },
        { id: 5, text: "5. Mi innervosisco per molte cose", factor: "NEUROTICISM", answer: null  },
        { id: 6, text: "6. Perdono gli altri quando fanno qualcosa di sbagliato", factor: "AGREEABLENESS", answer: null  },
        { id: 7, text: "7. So le risposte alle domande che fa l'insegnante", factor: "OPENNESS", answer: null  },
        { id: 8, text: "8. Mi piace stare con altre persone", factor: "EXTRAVERSION", answer: null  },
        { id: 9, text: "9. Ho sbalzi d'umore", factor: "NEUROTICISM", answer: null  },
        { id: 10, text: "10. Controllo il mio lavoro per assicurarmi che sia corretto", factor: "CONSCIENTIOUSNESS", answer: null  },
        { id: 11, text: "11. Mi arrabbio facilmente", factor: "NEUROTICISM", answer: null  },
        { id: 12, text: "12. Capisco il mio lavoro scolastico", factor: "OPENNESS", answer: null  },
        { id: 13, text: "13. Mi agito facilmente", factor: "NEUROTICISM", answer: null  },
        { id: 14, text: "14 Mi piace essere puntuale", factor: "CONSCIENTIOUSNESS", answer: null  },
        { id: 15, text: "15. Piango molto", factor: "NEUROTICISM", answer: null  },
        { id: 16, text: "16. Mi piace parlare con gli altri", factor: "EXTRAVERSION", answer: null  },
        { id: 17, text: "17. Tengo la mia stanza ordinata e pulita", factor: "CONSCIENTIOUSNESS", answer: null  },
        { id: 18, text: "18. Mi piace tenere le mie cose in ordine", factor: "CONSCIENTIOUSNESS", answer: null  },
        { id: 19, text: "19. Sono gentile anche con le persone che non mi piacciono", factor: "AGREEABLENESS", answer: null  },
        { id: 20, text: "20. Sono disordinato", factor: "CONSCIENTIOUSNESS", reversed: true, answer: null  },
        { id: 21, text: "21. Sono una persona timida", factor: "EXTRAVERSION", reversed: true, answer: null  },
        { id: 22, text: "22. Faccio amicizia facilmente", factor: "EXTRAVERSION", answer: null  },
        { id: 23, text: "23. Penso che le altre persone siano buone e oneste", factor: "AGREEABLENESS", answer: null  },
        { id: 24, text: "24. Mi piace prestare le mie cose agli altri", factor: "AGREEABLENESS", answer: null  },
        { id: 25, text: "25. Mi piace imparare cose nuove", factor: "OPENNESS", answer: null }
      ].sort((a, b) => a.id - b.id),
      responseOptions: [
        { emoji: "👎", value: 1, label: "Non è vero" },
        { emoji: "👉", value: 2, label: "È abbastanza vero" },
        { emoji: "👍", value: 3, label: "È decisamente vero" },
      ],

      answers: {},
      currentPage: 1,
      questionsPerPage: 5
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.questions.length / this.questionsPerPage);
    },
    currentQuestions() {
      const start = (this.currentPage - 1) * this.questionsPerPage;
      return this.questions.slice(start, start + this.questionsPerPage);
    },
    allAnswered() {
      return this.currentQuestions.every(question => question.answer !== null);
    }
  },
  methods: {
    setAnswer(question, option) {
      this.answers[question.id] = option.value;
      question.answer = option.value;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    canProceed() {
      return this.currentQuestions.every(q => this.answers[q.id]);
    },
    submitAnswers() {
      if (this.canProceed()) {
        const scores = this.calculateScores(this.answers);
        const payload = {
          agreeableness: scores.agreeableness,
          conscientiousness: scores.conscientiousness,
          extraversion: scores.extraversion,
          neuroticism: scores.neuroticism,
          openness: scores.openness,
          user: { id: this.user }
        };
        axios.post(config.baseUrl + `/questionnaire/addScores`, payload)
          .then(() => {
            this.$emit('complete', {
              openness: scores.openness,
              conscientiousness: scores.conscientiousness,
              extraversion: scores.extraversion,
              agreeableness: scores.agreeableness,
              neuroticism: scores.neuroticism,
              user: { id: this.user.id }
            });
          })
          .catch(error => {
            console.error('Error posting questionnaire:', error);
          });
      }
    },
    calculateScores(answers) {
      const scores = {
        AGREEABLENESS: [],
        CONSCIENTIOUSNESS: [],
        NEUROTICISM: [],
        EXTRAVERSION: [],
        OPENNESS: []
      };

      this.questions.forEach(q => {
        let score = answers[q.id];
        if (q.reversed) {
          score = 4 - score; // Reverse the score (1->3, 2->2, 3->1)
        }
        scores[q.factor].push(score);
      });

      // Calculate average for each factor and normalize to [1,100]
      const normalizedScores = {};
      Object.entries(scores).forEach(([factor, values]) => {
        const avg = values.reduce((a, b) => a + b, 0) / values.length;
        normalizedScores[factor.toLowerCase()] = Math.round(((avg - 1) / 2) * 100);
      });

      return normalizedScores;
    }
  },
};
</script>

<template>
  <div class="survey-wrapper">
    <h3>Questionario sulla personalità</h3>

    <div class="survey-container">
      <div v-for="question in currentQuestions" :key="question.id" class="question-item">
        <p class="question-text">{{ question.text }}</p>
        <div class="options">
          <button
            v-for="option in responseOptions"
            :key="option.value"
            @click="setAnswer(question, option)"
            :class="{ selected: question.answer === option.value }">
            <span class="emoji-img">{{ option.emoji }}</span>
            <span class="option-label">{{ option.label }}</span>
          </button>
        </div>
      </div>
      <div class="navigation">
        <button @click="previousPage" :disabled="currentPage === 1">Indietro</button>
        <button v-if="currentPage < totalPages" @click="nextPage" :disabled="!allAnswered">Avanti</button>
        <button v-else @click="submitAnswers" :disabled="!allAnswered">Invia Risposte</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
* {
    caret-color: transparent;
    box-sizing: border-box;
} 

.survey-wrapper {
    width: 80%;
    margin: 0 auto;
    padding: 20px;
    text-align: center;
    font-family: 'Arial', sans-serif;
    overflow: auto;
    color: white;
}

h3 {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 10px;
}

.description {
    font-size: 16px;
    margin-bottom: 20px;
    line-height: 1.6;
}

.survey-container {
    background: transparent;
    padding: 20px;
    border-radius: 10px;
    /*box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);*/
    width: 100%;
}

.question-item {
    padding: 15px;
    border-bottom: 1px solid #ddd;
}

.question-text {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
}

.options {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
}

.options button {
    background-color: #f9f9f9;
    border: 2px solid #ddd;
    border-radius: 8px;
    padding: 10px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.3s ease;
    font-size: 14px;
    width: 20%;
    text-align: center;
}

.emoji-img {
    font-size: 30px;
}


.options button:hover {
    background-color: #e0e0e0;
    transform: scale(1.05);
}

.options button.selected {
    background-color: #cce5ff;
    border-color: #007bff;
}

.submit-btn {
    margin-top: 20px;
    padding: 12px 30px;
    font-size: 18px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.submit-btn:hover {
    background-color: #0056b3;
}

.submit-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.navigation {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.navigation button {
    padding: 10px 20px;
    font-size: 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.navigation button:hover {
    background-color: #0056b3;
}

.navigation button:disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
    transition: none;
}

</style>